"use client";

import { padNumberWithZero } from "@/app/(main)/c/[slug]/utils";
import React, { useEffect, useMemo, useRef, useState } from "react";

const Countdown = ({ duration }: { duration: number }) => {
  const [seconds, setSeconds] = useState(duration);

  const interval = useRef<NodeJS.Timer>();

  useEffect(() => {
    const _interval = setInterval(() => {
      setSeconds((seconds) => seconds - 1);
    }, 1000);

    interval.current = _interval;

    return () => {
      clearInterval(_interval);
    };
  }, []);

  const formattedDuration = useMemo(() => {
    // Return days, hours, minutes, and seconds from the seconds value.

    const days = Math.floor(seconds / 86400);

    const hours = Math.floor((seconds % 86400) / 3600);

    const minutes = Math.floor(((seconds % 86400) % 3600) / 60);

    const _seconds = Math.floor(((seconds % 86400) % 3600) % 60);

    return {
      days: padNumberWithZero(days),
      hours: padNumberWithZero(hours),
      minutes: padNumberWithZero(minutes),
      seconds: padNumberWithZero(_seconds),
    };
  }, [seconds]);

  if (seconds <= 0) {
    return null;
  }

  return (
    <p
      className="text-sm md:text-2xl font-semibold"
      style={{
        backgroundImage:
          "linear-gradient(90deg, #c225bf -36.25%, #ecab2c 112.81%)",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
      }}
    >
      {formattedDuration.days ? (
        <>
          <span>{formattedDuration.days}D</span>
          <span className="mx-1">:</span>
        </>
      ) : null}
      {formattedDuration.hours ? (
        <>
          <span>{formattedDuration.hours}H</span>
          <span className="mx-1">:</span>
        </>
      ) : null}
      {formattedDuration.minutes ? (
        <>
          <span>{formattedDuration.minutes}M</span>
          <span className="mx-1">:</span>
        </>
      ) : null}
      {formattedDuration.seconds ? (
        <>
          <span>{formattedDuration.seconds}S</span>
        </>
      ) : null}
    </p>
  );
};

export default Countdown;
